/**
 * Replaces Error/PageNotFound.aspx (404).
 */
const PageNotFoundPage = () => {
  return (
    <div className="main-body-page grow" data-testid="page-not-found-page">
      <div className="text-center" style={{ padding: '40px 20px' }}>
        <h2>
          <i className="fa fa-exclamation-triangle"></i>&nbsp; 404 - The page or file you are looking for is not found.
        </h2>
      </div>
    </div>
  );
};

export default PageNotFoundPage;
